import React from "react";
import { useTreeSelect } from "./TreeSelectContext";
import "./TreeSelectItem.scss";
import Checkbox from "../Checkox/Checkbox";
import cs from "classnames";
import { getVisibleItems } from "./get-visible-items";

export const TreeSelectItem = ({ children, value, items, parent }) => {
  const treeSelect = useTreeSelect();

  const childItems = getVisibleItems(
    items.filter(item => item.parent === value),
    treeSelect.value
  );

  const childValues = getChildValues(items, value);

  const isParent = childItems.length !== 0;

  const isChecked = () => {
    if (isParent) {
      return (
        treeSelect.value.includes(value) ||
        treeSelect.value.filter(it => childValues.includes(it)).length !== 0
      );
    }

    return treeSelect.value.includes(value);
  };

  const isPartial = () => {
    if (isParent) {
      return (
        isChecked() &&
        treeSelect.value.filter(it => childValues.includes(it)).length <
          childValues.length
      );
    }

    return false;
  };

  const handleChange = () => {
    let newValue;

    if (isParent) {
      newValue = isChecked()
        ? treeSelect.value.filter(it => ![value, ...childValues].includes(it))
        : [...treeSelect.value, value, ...childValues];

      treeSelect.onChange(newValue);
    } else {
      if (parent) {
        const childValues = getChildValues(items, parent);

        const selectedChildValues = treeSelect.value.filter(it =>
          childValues.includes(it)
        );

        const shouldAddParentToValue =
          [...selectedChildValues, value].length === childValues.length;

        newValue = isChecked()
          ? treeSelect.value.filter(
              it => ![value, ...getParentValues(items, value)].includes(it)
            )
          : [
              ...treeSelect.value,
              value,
              ...(shouldAddParentToValue ? [parent] : [])
            ];

        treeSelect.onChange(newValue);
      } else {
        newValue = isChecked()
          ? treeSelect.value.filter(it => it !== value)
          : [...treeSelect.value, value];
      }
    }

    treeSelect.onChange(newValue);
  };

  const handleClick = () => {
    if (!isParent) {
      return;
    }

    treeSelect.onExpand(value);
  };

  const isExpanded = treeSelect.expandedIds.includes(value);

  return (
    <>
      <div
        className={cs(["tree-select-item"], {
          ["tree-select-item_expanded"]: isExpanded
        })}
      >
        {isParent ? (
          <div
            className={"tree-select-item__indicator"}
            onClick={handleClick}
          />
        ) : (
          <div
            style={{
              width: 20
            }}
          />
        )}
        <Checkbox
          checked={isChecked()}
          id={`item-${value}`}
          isPartial={isPartial()}
          onChange={handleChange}
        >
          {children}
        </Checkbox>
      </div>
      {isExpanded && (
        <div
          style={{
            marginLeft: 20
          }}
        >
          {childItems.map(({ label, value, ...item }) => {
            return (
              <TreeSelectItem key={value} value={value} items={items} {...item}>
                {label}
              </TreeSelectItem>
            );
          })}
        </div>
      )}
    </>
  );
};

const getChildValues = (items, value) => {
  const result = [];

  const loop = parent => {
    const childItems = items.filter(item => item.parent === parent);

    childItems.forEach(item => {
      result.push(item.value);

      loop(item.value);
    });
  };

  loop(value);

  return result;
};

const getParentValues = (items, parent) => {
  const result = [];

  const loop = parent => {
    const item = items.find(item => item.value === parent);

    if (!item) {
      return;
    }

    result.push(item.value);

    if (item.parent) {
      loop(item.parent);
    }
  };

  loop(parent);

  return result;
};
